import api from '@/lib/api'

const state = () => ({
  categories: [],
  frequent: [],

  request: {
    name: '',
    notes: '',
    phone: '',
    structure_type: '',
    service_id: -1,
    zipcode: '',
  },
})

const getters = {
  categories: state => state.categories,
  frequent: state => state.frequent,
  request: state => state.request,
}

const actions = { 
  async createRequest({commit}, customer_request ) {
    const payload = { customer_request }

    const result = await api.insecure_post('/qr/create_request', payload)
    if (result.ok) {
      commit('RESET_REQUEST')
      return { ok: true }
    }

    return { ...await result.json(), status: result.status, ok: false }
  },

  async isEnabled() {
    const result = await api.insecure_get('/qr/enabled')
    console.log(result)
    if (result.ok) {
      return { ok: true }
    } else if (result.status == 401) {
      return { ok: false }
    } else {
      return { ...await result.json(), status: result.status, ok: false }
    }
  },

  async loadCategories({ commit }) {
    const result = await api.insecure_get('/qr/categories')
    if (result.ok) {
      commit('SET_CATEGORIES', await result.json())
      return { ok: true }
    }

    console.log(result)

    if (result.status == 422) {
      commit('SET_FREQUENT', [])
      return { ...await result.json(), status: result.status, ok: false }
    }

    return result
  },

  async loadFrequent({ commit }) {
    const result = await api.insecure_get('/qr/frequent')

    if (result.ok) {
      commit('SET_FREQUENT', await result.json())
      return { ok: true }
    }

    console.log(result)

    if (result.status == 422) {
      commit('SET_FREQUENT', [])
      return { ...await result.json(), status: result.status, ok: false }
    }

    return result
  },

  async missingStageRequirements({ state }, stage) {
    switch (stage) {
      // eslint-disable-next-line no-fallthrough
      case 5:
        if (!state.request.name || !state.request.phone || !state.request.zipcode) { return true }

      // eslint-disable-next-line no-fallthrough
      case 4:
        if (!state.request.notes) { return true }

      // eslint-disable-next-line no-fallthrough
      case 3:
        if (!state.request.structure_type) { return true }

      // eslint-disable-next-line no-fallthrough
      case 2:
        if (state.request.service_id == -1) { return true }
    }

    return false
  },

  // eslint-disable-next-line no-empty-pattern
  async requestCode({}, { phone }) {
    const payload = { phone }

    const result = await api.insecure_post('/qr/request_code', payload)
    if (result.ok) {
      return { ok: true }
    }

    return { ...await result.json(), status: result.status, ok: false }
  },

  async setContact({ commit }, { name, phone, zipcode }) {
    commit('SET_CONTACT', { name, phone, zipcode })
  },

  async setNotes({ commit }, { notes }) {
    commit('SET_NOTES', notes)
  },

  async setPropertyType({ commit }, { structure_type }) {
    commit('SET_STRUCTURE_TYPE', structure_type)
  },

  async setService({ commit }, { service_id }) {
    commit('SET_SERVICE', service_id)
  }
}

const mutations = { 
  RESET_REQUEST (state) {
    state.request.service_id = -1
    state.request.structure_type = ''
    state.request.notes = ''
    state.request.name = ''
    state.request.phone = ''
    state.request.zipcode = ''
  },

  SET_CATEGORIES (state, categories) {
    state.categories = categories
  },

  SET_CONTACT (state, { name, phone, zipcode }) {
    state.request.name = name
    state.request.phone = phone
    state.request.zipcode = zipcode
  },

  SET_FREQUENT (state, frequent) {
    state.frequent = frequent
  },

  SET_NOTES (state, notes) {
    state.request.notes = notes
  },

  SET_STRUCTURE_TYPE (state, structure_type) {
    state.request.structure_type = structure_type
  },

  SET_SERVICE (state, service_id) {
    state.request.service_id = service_id
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}